import React, { Component } from "react";
import PropTypes from "prop-types";
import { hideModal } from "../../../../usecases/commons/hide-modal";
import { editBenefitModel } from "../../../../usecases/benefit-model/edit-benefit-model";

import { translate as t } from "../../../../infrastructure/translate/localization";
import CircleButton from "../../commons/CircleButton";
import BenefitGiftCard from "../../benefitsTabs/giftCard/BenefitGiftCard";
import "./giftCardModal.scss";

class GiftCardModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isReady: false,
      isFetch: true,
      disabledCardCodes: [],
      disabledCard: [],
    };
  }

  componentDidMount() {
    this.cardIsReady();
  }

  componentDidUpdate(prevProps) {
    const { isFetch, isReady } = this.state;
    const { giftCards } = this.props;
    if (isFetch && !isReady && prevProps.giftCards !== giftCards) {
      this.cardIsReady();
    }
  }

  componentWillUnmount() {
    const { benefit } = this.props;
    const { disabledCard } = this.state;
    editBenefitModel({
      ...benefit,
      disabledGiftCards: disabledCard,
    });
  }

  cardIsReady = () => {
    const { giftCards, benefit } = this.props;
    if (giftCards && giftCards.length > 0) {
      this.setState({
        isReady: true,
        isFetch: false,
        disabledCard: benefit.disabledGiftCards || [],
        disabledCardCodes: this.loadCodes(benefit.disabledGiftCards),
      });
    }
  };

  loadCodes = (cards) => {
    const codes = [];
    cards.map((card) => codes.push(card.code));
    return codes;
  };

  toggleCard = (code, provider) => {
    const { disabledCard, disabledCardCodes } = this.state;
    if (disabledCard.some((card) => card.code === code)) {
      const enabled = disabledCard.filter((card) => card.code !== code);
      const codes = disabledCardCodes.filter((cod) => cod !== code);
      this.setState({
        disabledCard: enabled,
        disabledCardCodes: codes,
      });
    } else {
      const disabled = { code, provider };
      this.setState({
        disabledCard: [...disabledCard, disabled],
        disabledCardCodes: [...disabledCardCodes, code],
      });
    }
  };

  render() {
    const { giftCards } = this.props;
    const { isFetch, isReady, disabledCardCodes } = this.state;
    return (
      <div className="modal-container">
        <CircleButton
          className="primary close-modal"
          icon="times"
          handlerClick={() => hideModal()}
        />
        <div className="gift-cards-benefit">
          <div className="modal-title">
            <div>
              <p className="title">
                {t("benefits-section.gift-cards-benefit.gift-cards")}
              </p>
              <p className="description">
                {t(
                  "benefits-section.gift-cards-benefit.gift-cards-description"
                )}
              </p>
            </div>
          </div>

          {!isFetch && isReady ? (
            <div className="grid-cards">
              {giftCards.map((card) => (
                <BenefitGiftCard
                  key={card.code}
                  name={card.name}
                  image={card.url}
                  disabled={disabledCardCodes.includes(card.code)}
                  handlerEnabled={() =>
                    this.toggleCard(card.code, card.provider)
                  }
                />
              ))}
            </div>
          ) : (
            <div className="grid-cards">
              {["1", "2", "3", "4", "5", "6", "7", "8", "9"].map((card) => (
                <BenefitGiftCard key={card} loading />
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
}

GiftCardModal.defaultProps = {};
GiftCardModal.propTypes = {
  giftCards: PropTypes.array.isRequired,
  benefit: PropTypes.object.isRequired,
};

export default GiftCardModal;
